module.exports = "/assets/data/3a2aa4fddd7d952d2f4b2dfb0c5a4442-NN12.data.json";